export default class DataLayerEnum {
    static BROCHURE_CARD_LINK_TYPE = 'data-layer-brochure-type'
    static BROCHURE_CARD_LINK_TRIGGER = `[${DataLayerEnum.BROCHURE_CARD_LINK_TYPE}]`
    static BROCHURE_CARD_TITLE = '.iris-card__content__title'
}
